import { action, payload } from 'ts-action';
import Feedback from '../../@types/feedback.interface';

export interface IFetchFeedbacksPayload {
    name: 'FEEDBACKS';
}

export interface IInsertFeedbackPayload {
    name: 'INSERT_FEEDBACK';
    data: Feedback;
}

export const FEEDBACKS = 'FEEDBACKS';
export const CLEAR_FEEDBACKS = 'CLEAR_FEEDBACKS';

export const fetchFeedbacks = action(
    FEEDBACKS,
    payload<{ feedbacks: Feedback[] }>()
);
export const clearFeedbacks = action(CLEAR_FEEDBACKS);

export type FeedbackActionType =
    | ReturnType<typeof fetchFeedbacks>
    | ReturnType<typeof clearFeedbacks>;

const FeedbackActionAPI = {
    clearFeedbacks,
};

export default FeedbackActionAPI;
